import api from "./api";

export const getUserProfile = async () => {
  const response = await api.get("/users/me");
  return response.data;
};

export const updateUserProfile = async (profileData) => {
  const response = await api.put("/users/me", profileData);
  return response.data;
};

export const verifyEmail = async (code) => {
  const response = await api.post("/auth/verify-email", { code });
  return response.data;
};

export const resendVerification = async () => {
  const response = await api.post("/auth/resend-verification");
  return response.data;
};

export const getEmailPreferences = async () => {
  const response = await api.get("/users/me/email-preferences");
  return response.data;
};

export const updateEmailPreferences = async (preferences) => {
  const response = await api.put("/users/me/email-preferences", preferences);
  return response.data;
};

export const requestUnsubscribeLink = async () => {
  const response = await api.post("/auth/request-unsubscribe-link");
  return response.data;
};

/**
 * Record that the current user has seen the in-app feature guide up to
 * `version`. The backend stores it monotonically (never downgrades), so it's
 * safe to call with the current CURRENT_GUIDE_VERSION on every dismissal.
 *
 * @param {number} version - the guide version that was shown/dismissed
 * @returns {Promise<{onboarding_guide_version: number}>}
 */
export const markOnboardingGuideSeen = async (version) => {
  const response = await api.post("/users/me/onboarding-seen", { version });
  return response.data;
};
